import { asColor } from '@atlassian/jira-issue-epic-color';
import {
	ChangeEventTypes,
	type ChangeEvent,
} from '@atlassian/jira-issue-view-model/src/change-type';
import type { IssueParent } from '../../../model/issue-parent/types';
import { cardCreateEndOfBacklogOptimistic } from '../../../state/actions/cards/create';
import { issueParentPatch } from '../../../state/actions/issue-parents/patch';
import { getEpicColorFieldId } from '../../../state/selectors/config';
import type { State, Action } from '../../../state/types';
import { updateRankOnChildrenOrderChange } from '../utils';

export const mapResponseToIssueParent = (
	issueParent: IssueParent,
	state: State,
	payload: ChangeEvent,
): null | Action => {
	const epicColorFieldId = getEpicColorFieldId(state);
	if (!payload.type || !issueParent) {
		return null;
	}

	if (payload.type === ChangeEventTypes.FIELD_CHANGED) {
		if (payload.meta.fieldId !== 'summary' && payload.meta.fieldId !== epicColorFieldId) {
			return null;
		}

		const issueParentContent: Partial<IssueParent> =
			payload.meta.fieldId === epicColorFieldId
				? { color: asColor(payload.meta.fieldValue) }
				: {
						[payload.meta.fieldId]: payload.meta.fieldValue,
					};

		return issueParentPatch({
			id: issueParent.id,
			issueParent: issueParentContent,
		});
	}

	if (payload.type === ChangeEventTypes.ISSUE_CHILDREN_ORDER_CHANGED) {
		return updateRankOnChildrenOrderChange(state, payload.meta);
	}

	if (payload.type === ChangeEventTypes.CHILD_ISSUE_ADDED) {
		return cardCreateEndOfBacklogOptimistic(payload);
	}

	return null;
};
